var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5C7.5 11.0166 7.93987 9.5666 8.76398 8.33323C9.58809 7.09986 10.7594 6.13856 12.1299 5.57091C13.5003 5.00325 15.0083 4.85472 16.4632 5.14411C17.918 5.4335 19.2544 6.14781 20.3033 7.1967C21.3522 8.2456 22.0665 9.58197 22.3559 11.0368C22.6453 12.4917 22.4968 13.9997 21.9291 15.3701C21.3614 16.7406 20.4001 17.9119 19.1668 18.736C17.9334 19.5601 16.4834 20 15 20H6.75C5.35761 20 4.02226 19.4469 3.03769 18.4623C2.05312 17.4777 1.5 16.1424 1.5 14.75C1.5 13.3576 2.05312 12.0223 3.03769 11.0377C4.02226 10.0531 5.35761 9.5 6.75 9.5C7.18925 9.49984 7.62687 9.55336 8.05313 9.65938",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.375L13.5 15.875L11.25 13.625",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApp);
export default __webpack_public_path__ + "static/media/WebApp.30ce899cde5bac9c3dbb7f13b971245f.svg";
export { ForwardRef as ReactComponent };